import React from 'react';
import { Col, Row } from 'reactstrap';
import dayjs from 'dayjs';

const Section = (props) => {
    const { filters = {} } = props;

    // Formatear fechas si existen
    const formattedStartDate = filters.start_date ? dayjs(filters.start_date).format('DD-MM-YYYY') : '';
    const formattedEndDate = filters.end_date ? dayjs(filters.end_date).format('DD-MM-YYYY') : '';

    return (
        <React.Fragment>
            <Row className="">
                <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div className="flex-grow-1">
                            {filters && Object.keys(filters).length > 0 && (
                                <div className="d-flex align-items-center gap-2 mb-3 mb-lg-0 flex-wrap">
                                    <span className="mb-0 text-muted">Filtros aplicados:</span>

                                    {filters.establishment_id && (
                                        <>
                                            <span>Establecimiento:</span>
                                            <span className="badge bg-primary fs-10">{filters.establishment_name}</span>
                                        </>
                                    )}

                                    {filters.establishment_type_id && (
                                        <>
                                            <span>Tipo Establecimiento:</span>
                                            <span className="badge bg-primary fs-10">{filters.establishment_type_name}</span>
                                        </>
                                    )}

                                    {filters.start_date && filters.end_date && (
                                        <>
                                            <span>Rango de Fechas:</span>
                                            <span className="badge bg-primary fs-10">{formattedStartDate} - {formattedEndDate}</span>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="mt-3 mt-lg-0">
                            <form action="#">
                                <Row className="g-3 mb-0 align-items-center">
                                    <div className="col-auto">
                                        <button
                                            type="button"
                                            className="btn btn-label btn-primary"
                                            onClick={props.rightCanvasBtn}
                                        >
                                            <i className="ri-filter-fill label-icon"></i> Filtros
                                        </button>
                                    </div>
                                </Row>
                            </form>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default Section;
